import { mergeData } from 'vue-functional-data-merge'

export default
{
	functional: true,

	props:
	{
		header:
		{
			type:    String,
			default: null,
		},

		variant:
		{
			type:    String,
			default: null,
		},

		time:
		{
			type:    String,
			default: null,
		},

		timeClass:
		{
			type:    String,
			default: null,
		},
	},

	render(h, { props, data, slots, children })
	{
		let childNodes = []
		const $slots   = slots()

		childNodes.push
		(
			h('div', { staticClass: 'timeline-badge', class: { [`bg-${props.variant}`]: Boolean(props.variant) } }),
		)

		childNodes.push
		(
			(function()
			{
				let bodyNodes = []

				if ( $slots.header || props.header )
				{
					bodyNodes.push(h(( $slots.default ) ? 'strong' : 'span', {}, $slots.header || [ h('span', { domProps: { innerHTML: props.header } }) ]))
				}

				if ( $slots.default )
				{
					bodyNodes.push(h('small', { staticClass: 'd-block' }, $slots.default))
				}

				return h('div', {}, bodyNodes)
			})()
		)

		if ( props.time || $slots.time )
		{
			childNodes.push
			(
				h('div', { staticClass: 'timeline-time', class: [ props.headerClass ] }, $slots.time || [ h('span', { domProps: { innerHTML: props.time } }) ])
			)
		}

		return h('li', mergeData(data, { staticClass: 'timeline-item' }), childNodes)
	}
}